import React from 'react';
import ReactDOM from 'react-dom';
import Sparkle from './Sparkle';
import soundManager from '../utils/soundEffects';

const Guestbook = ({ isOpen, onClose }) => {
  const [messages, setMessages] = React.useState([]);
  const [formData, setFormData] = React.useState({ name: '', message: '' });

  React.useEffect(() => {
    // Load messages from localStorage
    const stored = localStorage.getItem('guestbookMessages');
    if (stored) {
      setMessages(JSON.parse(stored));
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    soundManager.playSuccess();
    
    const newMessage = {
      id: Date.now(),
      name: formData.name,
      message: formData.message,
      timestamp: new Date().toLocaleString()
    };
    
    const updatedMessages = [newMessage, ...messages];
    setMessages(updatedMessages);
    localStorage.setItem('guestbookMessages', JSON.stringify(updatedMessages));
    
    setFormData({ name: '', message: '' });
  };

  if (!isOpen) return null;

  const modalContent = (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999,
      padding: '16px'
    }}>
      {/* Backdrop */}
      <div 
        onClick={onClose}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 99998
        }}
      ></div>
      
      {/* Modal */}
      <div className="window" style={{ 
        width: '100%', 
        maxWidth: '700px', 
        maxHeight: '90vh', 
        overflow: 'hidden',
        position: 'relative',
        zIndex: 100000
      }}>
        <div className="window-header flex justify-between items-center">
          <span>✍️ My Guestbook ✍️</span>
          <Sparkle onInteract={() => {
            soundManager.playClick();
            onClose();
          }}>
            <button className="text-white hover:text-red-300 font-bold text-lg px-2">
              X
            </button>
          </Sparkle>
        </div>
        <div className="window-body max-h-[80vh] overflow-y-auto">
          {/* Sign Form */}
          <div className="bg-pink-50 p-4 border-2 border-pink-400 mb-4">
            <h3 className="font-bold text-lg mb-3 pixel-text" style={{ color: '#ff1493' }}>
              Sign My Guestbook! ✨
            </h3>
            <form onSubmit={handleSubmit} className="space-y-3">
              <div>
                <label className="block text-xs font-bold mb-1">Your Name:</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  onClick={() => soundManager.playClick()}
                  required
                  className="w-full px-2 py-1 border-2 border-gray-400 text-sm focus:outline-none focus:border-pink-400"
                  placeholder="Enter your name..."
                />
              </div>
              <div>
                <label className="block text-xs font-bold mb-1">Your Message:</label>
                <textarea
                  value={formData.message}
                  onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                  onClick={() => soundManager.playClick()}
                  required
                  rows="3"
                  className="w-full px-2 py-1 border-2 border-gray-400 text-sm focus:outline-none focus:border-pink-400 resize-none"
                  placeholder="Leave a message..."
                ></textarea>
              </div>
              <Sparkle onInteract={() => soundManager.playClick()}>
                <button type="submit" className="retro-btn w-full">
                  ✨ Sign Guestbook!
                </button>
              </Sparkle>
            </form>
          </div>

          {/* Messages Wall */}
          <div>
            <h3 className="font-bold text-lg mb-3 pixel-text" style={{ color: '#ff1493' }}>
              Messages ({messages.length}) 💖
            </h3>
            {messages.length === 0 ? (
              <div className="text-center p-8 bg-purple-50 border-2 border-dashed border-purple-300">
                <p className="text-sm text-gray-600">No messages yet! Be the first to sign! 🌟</p>
              </div>
            ) : (
              <div className="space-y-3">
                {messages.map((msg) => (
                  <div key={msg.id} className="bg-gradient-to-r from-yellow-50 to-pink-50 p-3 border-2 border-purple-300">
                    <div className="flex justify-between items-start mb-2">
                      <p className="font-bold text-sm" style={{ color: '#ff1493' }}>
                        👤 {msg.name}
                      </p>
                      <span className="text-xs text-gray-500">{msg.timestamp}</span>
                    </div>
                    <p className="text-sm">{msg.message}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default Guestbook;
